module.exports = __webpack_public_path__ + "img/history-original.6491c4e3.png";